import { computed, inject } from '@angular/core';
import { MultiLangText } from '@libs/core/lib/pipes/lang-select.pipe';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { TranslateService } from '@ngx-translate/core';

export const LanguageSwitcherStore = signalStore(
  { providedIn: 'root' },
  withState<{ currentLangCode: string; supportedLanguages: Language[] }>({
    currentLangCode: 'en',
    supportedLanguages: [
      { code: 'ar', name: 'العربية', dir: 'rtl' },
      { code: 'en', name: 'English', dir: 'ltr' },
    ],
  }),
  withMethods((store, translateService = inject(TranslateService)) => ({
    setLanguage(lang: Language, options?: { init?: boolean }): void {
      document.documentElement.dir = lang.dir;
      document.documentElement.lang = lang.code;
      patchState(store, { currentLangCode: lang.code });
      if (!options?.init) {
        translateService.use(lang.code);
        localStorage.setItem('lang', lang.code);
        console.log({ lang: lang.code });
        window.location.reload();
      }
    },
  })),
  withComputed((store) => ({
    currentLang: computed(() => {
      return store.supportedLanguages().find((l) => l.code === store.currentLangCode());
    }),
  })),

  withMethods((store) => ({
    init(): void {
      const storedLang = localStorage.getItem('lang') || 'ar';
      const lang = store.supportedLanguages().find((l) => l.code === storedLang) || store.supportedLanguages()[0];
      store.setLanguage(lang, { init: true });
    },
    // TODO: i'm not sure if this is the best way to do it
    translateMultiLangText(value: MultiLangText | null | undefined): string {
      if (!value) return '';
      const currentLang = store.currentLang()?.code ?? 'ar';
      return (value[currentLang] as string) ?? value.ar ?? value.en ?? '';
    },
  })),
);

type Language = {
  code: 'ar' | 'en';
  name: string;
  dir: 'rtl' | 'ltr';
};
